<script setup lang="ts">
const emit = defineEmits<{ close: [] }>()
const props = defineProps<{ game: Game, availableWriters: Player[] }>()

const { callAction } = useTournamentActions()

const search = ref('')

const { handleSubmit, setFieldValue } = useForm<{ writer: number | null }>({
  initialValues: {
    writer: props.game.writer.id,
  },
})

function clearWriter() {
  setFieldValue('writer', null)
  updateWriter()
}

const { t } = useI18n()

const updateWriter = handleSubmit(({ writer }) => {
  if (!props.game.tournament_id) {
    return
  }
  callAction(props.game.tournament_id, 'update-writer', {
    game_id: props.game.id,
    writer_id: writer,
  }).then(() => {
    emit('close')
  }).catch(() => {
    useSonner.error(t('Could not update writer'))
  })
})

const filteredWriters = computed(() => {
  return props.availableWriters.filter(writer => writer?.name.toLowerCase().includes(search.value.toLowerCase()))
})
</script>

<template>
  <UiDialog
    :open="true"
    @update:open="emit('close')"
  >
    <UiDialogContent
      :title="$t('Select writer')"
      :description="game.label"
    >
      <UiFormSimple
        id="writer-form"
        @submit="updateWriter"
      >
        <UiFullSelect
          name="writer"
          :label="$t('Writer')"
        >
          <UiSelectItem
            v-for="writerOption in filteredWriters"
            :key="writerOption!.id"
            :value="writerOption!.id"
          >
            {{ writerOption!.name }}
          </UiSelectItem>
        </UiFullSelect>
      </UiFormSimple>
      <template #footer>
        <UiDialogFooter>
          <UiButton
            variant="destructive"
            :text="$t('Remove writer')"
            @click="clearWriter()"
          />
          <UiButton
            variant="success"
            :text="$t('Save')"
            @click="updateWriter()"
          />
        </UiDialogFooter>
      </template>
    </UiDialogContent>
  </UiDialog>
</template>
